// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cf-title{font-size:1.5rem;font-weight:300;font-family:\"Montserrat\"}.formWhite{padding:20px 10px;border-radius:20px;box-shadow:0 0 20px 0 rgba(0,0,0,.1)}.formWhite,.formWhite label{background:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
